(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  window.onscroll = function() {myFunction()};

  var header = document.getElementById("sticky-header");
  var sticky = header.offsetTop;

  function myFunction() {
    if (window.pageYOffset > sticky) {
      header.classList.add("sticky-bar");
    } else {
      header.classList.remove("sticky-bar");
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header_old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-video-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('instagram-video-stories')) {
    customElements.define(
      'instagram-video-stories',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;

          this.controller = new AbortController();

          const on = (target, type, callback, options = {}) => {
            target.addEventListener(type, callback, {
              ...options,
              signal: this.controller.signal
            });
          };

          this.dialog = this.querySelector('.ivs__dialog');
          this.player = this.querySelector('.ivs__player');
          this.caption = this.querySelector('.ivs__caption');
          this.overlay = this.querySelector('.ivs__overlay');
          this.collectionButton = this.querySelector('.ivs__collection-button');
          this.status = this.querySelector('.ivs__status');
          this.progress = this.querySelector('.ivs__progress');
          this.track = this.querySelector('.ivs__track');

          this.buttons = Array.from(
            this.querySelectorAll('.ivs__open:not([disabled])')
          );

          this.token = 0;
          this.index = 0;
          this.touch = null;
          this.player.muted = true;

          const action = name => {
            return this.querySelector('[data-action="' + name + '"]');
          };

          this.sync = () => {
            const svg = path => {
              return (
                '<svg viewBox="0 0 24 24" aria-hidden="true">' +
                path +
                '</svg>'
              );
            };

            action('play').innerHTML = svg(
              this.player.paused
                ? '<path d="m9 5 11 7-11 7Z"/>'
                : '<path d="M8 5v14M16 5v14"/>'
            );

            action('play').setAttribute(
              'aria-label',
              this.player.paused
                ? this.dataset.play
                : this.dataset.pause
            );

            action('mute').innerHTML = svg(
              '<path d="M11 4 6 8H3v8h3l5 4Z"/>' +
              (
                this.player.muted
                  ? '<path d="m16 9 5 6m0-6-5 6"/>'
                  : '<path d="M15 8a6 6 0 0 1 0 8M18 5a10 10 0 0 1 0 14"/>'
              )
            );

            action('mute').setAttribute(
              'aria-label',
              this.player.muted
                ? this.dataset.unmute
                : this.dataset.mute
            );
          };

          this.play = async () => {
            const token = this.token;
            this.status.textContent = '';

            try {
              await this.player.play();
            } catch (error) {
              if (
                token === this.token &&
                this.dialog.open &&
                error.name !== 'AbortError'
              ) {
                this.status.textContent =
                  error.name === 'NotAllowedError'
                    ? this.dataset.play
                    : this.dataset.error;
              }
            }

            if (token === this.token) {
              this.sync();
            }
          };

          this.show = next => {
            if (!this.buttons.length) return;

            const restoreCollectionFocus =
              document.activeElement === this.collectionButton;

            this.token++;
            this.player.pause();
            this.touch = null;

            this.index =
              ((next % this.buttons.length) + this.buttons.length) %
              this.buttons.length;

            const button = this.buttons[this.index];

            const captionText =
  (button.dataset.caption || '').trim() ||
  button.dataset.label ||
  '';

const collectionUrl = button.dataset.collectionUrl || '';
const collectionTitle = (button.dataset.collectionTitle || '').trim();
const storyLabel = (button.dataset.label || '').trim();
const buttonLabel = storyLabel ? storyLabel + ' Collection' : '';
const showCollectionButton = Boolean(collectionUrl && buttonLabel);

this.caption.textContent = '';
            this.caption.scrollTop = 0;

            this.collectionButton.textContent = buttonLabel;
            this.collectionButton.hidden = !showCollectionButton;

            if (showCollectionButton) {
              this.collectionButton.setAttribute('href', collectionUrl);
            } else {
              this.collectionButton.removeAttribute('href');
            }

            this.overlay.hidden = !captionText && !showCollectionButton;

            if (restoreCollectionFocus && !showCollectionButton) {
              action('close').focus();
            }

            this.progress.style.width = '0%';
            this.track.setAttribute('aria-valuenow', '0');
            this.status.textContent = '';

            this.player.src = button.dataset.src;
            this.player.load();
            this.play();
          };

          this.open = (index, button) => {
            document
              .querySelectorAll('instagram-video-stories')
              .forEach(other => {
                if (other !== this && other.dialog?.open) {
                  other.dialog.close();
                  other.cleanup();
                }
              });

            if (!this.dialog.open) {
              this.returnFocus = button;
              this.oldOverflow = document.body.style.overflow;

              this.dialog.showModal();

              document.body.style.overflow = 'hidden';
              this.locked = true;
            }

            this.show(index);
            action('close').focus();
          };

          this.buttons.forEach((button, index) => {
            on(button, 'click', () => this.open(index, button));
          });

          on(action('close'), 'click', () => this.dialog.close());

          on(action('next'), 'click', () => {
            this.show(this.index + 1);
          });

          on(action('previous'), 'click', () => {
            this.show(this.index - 1);
          });

          on(action('play'), 'click', () => {
            this.player.paused ? this.play() : this.player.pause();
          });

          on(action('mute'), 'click', () => {
            this.player.muted = !this.player.muted;
            this.sync();
          });

          on(this.player, 'click', () => {
            this.player.paused ? this.play() : this.player.pause();
          });

          ['play', 'pause', 'volumechange'].forEach(type => {
            on(this.player, type, this.sync);
          });

          on(this.collectionButton, 'click', () => {
            this.player.pause();
          });

          on(this.player, 'error', () => {
            if (this.dialog.open && this.player.hasAttribute('src')) {
              this.status.textContent = this.dataset.error;
            }
          });

          on(this.player, 'timeupdate', () => {
            const percent =
              Number.isFinite(this.player.duration) &&
              this.player.duration > 0
                ? Math.min(
                    100,
                    this.player.currentTime / this.player.duration * 100
                  )
                : 0;

            this.progress.style.width = percent + '%';

            this.track.setAttribute(
              'aria-valuenow',
              String(Math.round(percent))
            );
          });

          on(this.player, 'ended', () => {
            if (!this.dialog.open) return;

            if (this.index < this.buttons.length - 1) {
              this.show(this.index + 1);
            } else {
              this.dialog.close();
            }
          });

          on(this.dialog, 'close', () => {
            if (!this.dialog.open) this.cleanup();
          });

          on(this.dialog, 'click', event => {
            if (event.target !== this.dialog) return;

            const rect = this.dialog.getBoundingClientRect();

            if (
              event.clientX < rect.left ||
              event.clientX > rect.right ||
              event.clientY < rect.top ||
              event.clientY > rect.bottom
            ) {
              this.dialog.close();
            }
          });

          on(this.dialog, 'keydown', event => {
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
              event.preventDefault();

              this.show(
                this.index + (event.key === 'ArrowRight' ? 1 : -1)
              );
            } else if (
              event.code === 'Space' &&
              event.target === this.player
            ) {
              event.preventDefault();
              this.player.paused ? this.play() : this.player.pause();
            }
          });

          const stage = this.querySelector('.ivs__stage');

          on(
            stage,
            'touchstart',
            event => {
              if (
                event.touches.length !== 1 ||
                event.target.closest('button, a, .ivs__overlay')
              ) {
                this.touch = null;
                return;
              }

              this.touch = {
                x: event.touches[0].clientX,
                y: event.touches[0].clientY
              };
            },
            { passive: true }
          );

          on(
            stage,
            'touchend',
            event => {
              if (!this.touch || !event.changedTouches.length) return;

              const dx =
                event.changedTouches[0].clientX - this.touch.x;

              const dy =
                event.changedTouches[0].clientY - this.touch.y;

              this.touch = null;

              if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
                this.show(this.index + (dx < 0 ? 1 : -1));
              }
            },
            { passive: true }
          );

          on(
            stage,
            'touchcancel',
            () => {
              this.touch = null;
            },
            { passive: true }
          );

          on(document, 'visibilitychange', () => {
            if (document.hidden) {
              this.player.pause();
            }
          });

          on(document, 'shopify:block:select', event => {
            if (event.detail.sectionId !== this.dataset.sectionId) {
              return;
            }

            const block = Array.from(
              this.querySelectorAll('.ivs__story')
            ).find(item => {
              return item.dataset.blockId === event.detail.blockId;
            });

            if (block) {
              block.scrollIntoView({
                behavior: 'auto',
                block: 'nearest',
                inline: 'center'
              });
            }
          });

          this.sync();
        }

        cleanup() {
          this.token++;
          this.touch = null;

          this.player.pause();
          this.player.removeAttribute('src');
          this.player.load();

          if (this.locked) {
            document.body.style.overflow = this.oldOverflow;
            this.locked = false;
          }

          if (this.returnFocus?.isConnected) {
            this.returnFocus.focus();
          }

          this.returnFocus = null;
        }

        disconnectedCallback() {
          if (!this.controller) return;

          this.cleanup();
          this.controller.abort();
          this.controller = null;

          if (this.dialog.open) {
            this.dialog.close();
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
